/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraBusinessApprovalsProjectSettingsAppMemoQuery$parameters.ts';
import type { JiraBusinessApprovalsProjectSettingsAppMemoQuery } from './__generated__/JiraBusinessApprovalsProjectSettingsAppMemoQuery.graphql.ts';

type ApprovalsProjectSettingsEntryPointComponent = EntryPointComponent<
	{
		approvalsSettingsQuery: JiraBusinessApprovalsProjectSettingsAppMemoQuery;
	},
	{},
	{},
	{}
>;

export const approvalsProjectSettingsEntryPoint: EntryPoint<
	ApprovalsProjectSettingsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<ApprovalsProjectSettingsEntryPointComponent>(
		/* webpackChunkName: "async-business-approvals-project-settings-entrypoint" */ './JiraBusinessApprovalsProjectSettingsAppMemo.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				approvalsSettingsQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
			},
		};
	},
});
